import "./GroupsDropdown.styles.scss";
import React from "react";
import ReactSelect from "react-select";
import { useParams } from "react-router-dom";
import { useGetGroups } from "utils/hooks";
import {
  GroupOption,
  allGroupsOption,
  ValueContainer,
  MultiValue,
} from "./components/GroupOptions";
import { useTranslation } from "react-i18next";
interface GroupsDropdownProps {
  hint?: string;
  menuPlacement?: string;
  components?: any;
  isDisabled?: boolean;
  register?: any;
  name?: string;
  label?: string | null;
  placeholder?: string;
  defaultGroup?: {
    uuid: string;
    name: string;
  } | null;
  rules?: any;
  onChange: (selected: any) => void;
  isMulti?: boolean;
  allowSelectAll?: boolean;
  closeMenuOnSelect?: boolean;
  hideSelectedOptions?: boolean;
  value?: any;
  isClearable?: boolean;
  styles?: any;
  className?: string;
  defaultToText?: boolean;
}

const GroupsDropdown = ({
  components,
  isDisabled,
  name,
  label = null,
  defaultGroup,
  onChange,
  isMulti = false,
  allowSelectAll = false,
  closeMenuOnSelect = true,
  hideSelectedOptions = true,
  value,
  isClearable = true,
  styles = {},
  className,
  defaultToText = false,
  placeholder,
  menuPlacement = "bottom",
}: GroupsDropdownProps) => {
  const { t } = useTranslation(["common"]);
  const { groupStatus } = useParams<{
    groupStatus: string;
  }>();
  const { groups } = useGetGroups({});
  const currentPlaceholder = placeholder || t("confirmed_actions.sending");
  const mappedGroups = groups
    .filter((group) => group.status.toLowerCase() === groupStatus)
    .map((group: { uuid: string; name: string }) => {
      return {
        value: group.uuid,
        label: group.name,
      };
    });

  const mappedCurrentGroup = {
    value: defaultGroup && defaultGroup.uuid,
    label: `${defaultGroup?.name}`,
  };

  const options = allowSelectAll
    ? [allGroupsOption, ...mappedGroups]
    : mappedGroups;

  if (defaultToText && groups.length === 1) {
    return <div className="default-to-text">{`${defaultGroup?.name}`}</div>;
  }

  return (
    <div className={`select ${className}`}>
      {label && <label className="select__label">{label}</label>}
      <ReactSelect
        value={value || defaultGroup}
        isClearable={isClearable}
        className={`select ${className}`}
        styles={styles}
        name={name}
        placeholder={currentPlaceholder}
        options={options}
        components={{
          Option: GroupOption,
          ValueContainer,
          MultiValue,
          ...components,
        }}
        defaultValue={
          defaultGroup || mappedCurrentGroup.value ? mappedCurrentGroup : null
        }
        isDisabled={isDisabled}
        noOptionsMessage={() => t("groups.no_groups_message")}
        onChange={(
          selected: { value: string }[] | null,
          event: { action: string }
        ) => {
          if (selected !== null && selected.length > 0) {
            if (selected[selected.length - 1].value === allGroupsOption.value) {
              return onChange(options);
            }
            let result:
              | { value: string; label: string }[]
              | { value: string }[] = [];
            if (selected.length === options.length - 1) {
              if (selected.includes(allGroupsOption)) {
                result = selected.filter(
                  (option: { value: string }) =>
                    option.value !== allGroupsOption.value
                );
              } else if (event.action === "select-option") {
                result = options;
              }
              return onChange(result);
            }
          }

          return onChange(selected);
        }}
        isMulti={isMulti}
        closeMenuOnSelect={closeMenuOnSelect}
        hideSelectedOptions={hideSelectedOptions}
        menuPlacement={menuPlacement}
      />
    </div>
  );
};

export default GroupsDropdown;
